import { themes } from "../../modules/theme";

export const AlertType = {
  DANGER: "danger",
  WARNING: "warning",
};

export const ToastSettings = {
  Success: {
    color: themes.default.panache,
    icon: themes.default.yellowGreen,
  },
  Warning: {
    color: themes.default.lemon,
    icon: themes.default.brightSun,
  },
  Error: {
    color: themes.default.mistyRose,
    icon: themes.default.cardinal,
  },
};
